import { ComponentType, createContext } from "react";

/// AUTOGENERATED, DO NOT EDIT, see `scripts/icons.clj`

export interface IIconsContext {
  ExclamationCircle: ComponentType;
  MuxArrowLeft: ComponentType;
  MuxArrowRight3: ComponentType;
  MuxAutoFilter: ComponentType;
  MuxChevronDown2: ComponentType;
  MuxChevronRight: ComponentType;
  MuxChevronUp2: ComponentType;
  MuxCopy: ComponentType;
  MuxDrag: ComponentType;
  MuxDragHandle2: ComponentType;
  MuxEditColumns: ComponentType;
  MuxExport: ComponentType;
  MuxFavorite: ComponentType;
  MuxGoTo: ComponentType;
  MuxInfoCircle: ComponentType;
  MuxInfoRedCircle: ComponentType;
  MuxPencil: ComponentType;
  MuxPencilRename: ComponentType;
  MuxPlusCircle: ComponentType;
  MuxRegPlus: ComponentType;
  MuxSetting: ComponentType;
  MuxTabFilter: ComponentType;
  MuxTabFolder: ComponentType;
  MuxToggle: ComponentType;
  MuxToggle2: ComponentType;
  MuxTrash: ComponentType;
  MuxX: ComponentType;
}

export const IconsContext = createContext<IIconsContext | undefined>(undefined);

export const IconsProvider = IconsContext.Provider;
